import Link from 'next/link'
import { Fragment } from 'react'
import { LogoMark } from '@/components/generals/logo'
import { NewsletterCard } from '@/components/generals/newsletter-card'
import { FOOTER_COLUMNS, PRIMARY_NAV } from '@/constants/navigation'

const QUICK_LINKS = [...PRIMARY_NAV, { label: 'Contacts', href: '/contact' }]

export const Footer = () => {
    return (
        <footer className='relative overflow-hidden bg-black pt-24 sm:pt-32'>
            <div aria-hidden='true' className='pointer-events-none absolute inset-x-0 top-0 h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.12),transparent)]' />

            <div className='shell'>
                <div className='grid items-end gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,500px)] lg:gap-16'>
                    <div>
                        <Link href='/' aria-label='Verdane home' className='group inline-flex items-center gap-3.5 text-cream'>
                            <LogoMark className='size-10 sm:size-12' />

                            <span className='text-[2.4rem] font-medium leading-none tracking-[-0.05em] sm:text-5xl'>
                                Verdane
                            </span>
                        </Link>

                        <nav aria-label='Quick links' className='mt-8'>
                            <ul className='flex flex-wrap items-center gap-y-2 text-[15px] text-cream/65'>
                                {QUICK_LINKS.map((link, index) => (
                                    <Fragment key={link.href}>
                                        {index > 0 && (
                                            <li aria-hidden='true' className='px-3 text-cream/25'>
                                                /
                                            </li>
                                        )}

                                        <li>
                                            <Link href={link.href} className='transition-colors duration-300 hover:text-cream'>
                                                {link.label}
                                            </Link>
                                        </li>
                                    </Fragment>
                                ))}
                            </ul>
                        </nav>

                        <p className='mt-8 max-w-sm text-sm leading-relaxed text-cream/45'>
                            One calm place for all of your money, with an AI advisor that understands it and real people for the decisions that count.
                        </p>
                    </div>

                    <NewsletterCard />
                </div>

                <div className='mt-20 grid gap-12 border-t border-white/[0.08] pt-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10'>
                    {FOOTER_COLUMNS.map(column => (
                        <nav key={column.title} aria-label={column.title}>
                            <p className='text-[11px] font-medium uppercase tracking-[0.3em] text-cream/40'>
                                {column.title}
                            </p>

                            <ul className='mt-5 space-y-3'>
                                {column.links.map(link => (
                                    <li key={link.href}>
                                        <Link href={link.href} className='text-sm text-cream/70 transition-colors duration-300 hover:text-cream'>
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    ))}
                </div>

                <div className='mt-16 flex flex-col gap-6 border-t border-white/[0.08] pt-8 text-xs leading-relaxed text-cream/40 md:flex-row md:items-start md:justify-between'>
                    <p className='max-w-2xl'>
                        Verdane provides financial guidance and access to licensed advisors. What the AI advisor shares is for education and is not a recommendation to buy or sell any security. All investing carries risk, including the possible loss of principal, and past performance is no guarantee of future results.
                    </p>

                    <p className='shrink-0' suppressHydrationWarning>
                        &copy; {new Date().getFullYear()} Verdane, Inc. All rights reserved.
                    </p>
                </div>
            </div>

            <div aria-hidden='true' className='pointer-events-none mt-24 select-none pb-6 sm:mt-32 sm:pb-10'>
                <p className='text-fade text-center text-[25vw] font-medium leading-[0.8] tracking-[-0.075em]'>
                    Verdane
                </p>
            </div>
        </footer>
    )
}
